import { Layout, Button, Row, Col } from "antd";
import { RiMenuFill } from "react-icons/ri";
import { motion } from "framer-motion";

import HeaderUser from "./HeaderUser";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { theme } from "../../../redux/customise/customiseActions";

const { Header } = Layout;

export default function MenuHeader(props) {
  const { setVisible } = props;
  const [isDarkMode, setIsDarkMode] = useState(
    localStorage.getItem("theme") === "dark"
  );
  const dispatch = useDispatch();

  // Mobile Sidebar
  const showDrawer = () => {
    setVisible(true);
  };

  const handleThemeModeChange = () => {
    if (isDarkMode) {
      document.querySelector("body").classList.replace("dark", "light");
      localStorage.setItem("theme", "light");
      dispatch(theme("light"));
    } else {
      document.querySelector("body").classList.replace("light", "dark");
      localStorage.setItem("theme", "dark");
      dispatch(theme("dark"));
    }
    setIsDarkMode(!isDarkMode);
  };

  // Children
  const headerChildren = () => {
    return (
      <Row
        className="hp-w-100 hp-position-relative"
        align="middle"
        justify="space-between"
      >
        <Col className="hp-mobile-sidebar-button hp-mr-24">
          <Button
            type="none"
            ghost
            className="hp-mobile-sidebar-button hp-border-none"
            onClick={showDrawer}
            icon={
              <RiMenuFill
                size={24}
                className="remix-icon hp-text-color-black-80 hp-text-color-dark-30"
              />
            }
          />
        </Col>

        <Col style={{ flexGrow: 1 }}>
          <Row justify="end" align="middle">
            <HeaderUser />
            <Row
              justify="start"
              style={{ marginLeft: "8px", flexDirection: "column" }}
            >
              <p className="hp-mb-4 hp-font-weight-500 hp-text-color-black-100 hp-text-color-dark-0 hp-p1-body">
                User name
              </p>
              <p className="hp-mb-0 hp-caption hp-text-color-black-60 hp-text-color-dark-50">
                id
              </p>
            </Row>
            <Button
              type="text"
              onClick={handleThemeModeChange}
              style={{
                marginLeft: 24,
                borderRadius: "50%",
                width: "44px",
                height: "44px",
                backgroundColor: isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.05)'
              }}
              icon={
                isDarkMode ? (
                  <i className="ph-fill ph-sun hp-theme-icon" style={{ fontSize: '24px'}}/>
                ) : (
                  <i className="ph-fill ph-moon hp-theme-icon" style={{ fontSize: '24px'}}/>
                )
              }
            />
          </Row>
        </Col>
      </Row>
    );
  };

  return (
    <Header className="hp-border-color-black-30 hp-border-color-dark-80 hp-bg-black-0 hp-bg-color-dark-90">
      <Row justify="center" className="hp-w-100 hp-header">
        <Col xxl={17} xl={22} span={24}>
          <motion.div
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ type: "spring", duration: 0.5, delay: 0.1 }}
            className="hp-w-100"
          >
            {headerChildren()}
          </motion.div>
        </Col>
      </Row>
    </Header>
  );
}
